import { render, staticRenderFns } from "./body-item.vue?vue&type=template&id=6a72e8ff&"
import script from "./body-item.vue?vue&type=script&lang=js&"
export * from "./body-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports